import * as React from 'react'
import useTranslation from '../../shared/TranslationProvider'
import { Button } from '../../../lib/ui/button'
import YnsIcon from '~/components/icons/YnsIcon'
import useSavedCourses from './SavedCoursesProvider'

export function DeleteCell({ row }) {
  const savedCourse = row.original
  const { t } = useTranslation('DeleteCell')
  const { deleteCourse } = useSavedCourses()

  const handleDeleteCourse = () => {
    deleteCourse(savedCourse)
  }

  return (
    <Button
      onClick={handleDeleteCourse}
      className="bg-transparent hover:bg-transparent"
      title={t('delete')}
      type="button"
    >
      <YnsIcon
        name={'trash'}
        className={
          'bg-transparent text-red-500 hover:bg-transparent hover:text-red-400'
        }
      />
    </Button>
  )
}
